import { render, staticRenderFns } from "./BarEchart.vue?vue&type=template&id=0319fc5a&scoped=true&"
import script from "./BarEchart.vue?vue&type=script&lang=js&"
export * from "./BarEchart.vue?vue&type=script&lang=js&"
import style0 from "./BarEchart.vue?vue&type=style&index=0&id=0319fc5a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0319fc5a",
  null
  
)

export default component.exports